import Actions from '../Collection/actions'

const actions = Actions.get('SUBCATEGORY_');

export default actions;
